import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError, } from 'rxjs/operators';

import {
    FETCH_ORGANISATION_LIST,
    FETCH_ORGANISATION_LIST_ERROR,
    SET_ORGANISATION_LIST
} from '../../constants';



const fetchOrganisationList = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_ORGANISATION_LIST),
    switchMap(action => {
      if (!action || !action.appId) {
        return of({
          type: FETCH_ORGANISATION_LIST_ERROR,
          error: { message: 'appId is required' },
        });
      }
      return ajax({
        url: `${state$.value.auth.poiServer}/apps/${action.appId}/organizations`,
        headers: {
          Authorization: `Bearer ${state$.value.auth.token}`,
        },
        responseType: 'json',
        crossDomain: true,
        method: 'POST',
      }).pipe(
        map(response => {
          return {
            type: SET_ORGANISATION_LIST,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_ORGANISATION_LIST_ERROR,
            error,
          })
        )
      );
    })
  );

export default fetchOrganisationList;
